// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__13eok","unreadBadge":"styles_unreadBadge__2Jyds","modalContent":"styles_modalContent__APcMi","modal":"styles_modal__16Gdh"};